import Image from 'global/Image';
import { Common } from '@stockbit/ui';
import CompanyIcon from '../components/CompanyIcon';
import { StockChipWrapper } from './styled';

const { Flex, Text } = Common;

interface IStockChip {
  symbol: string;
  onRemove: (symbol: string) => void;
}

const StockChip = ({
  symbol,
  onRemove,
}: IStockChip) => (
  <StockChipWrapper>
    <Flex align="center">
      <CompanyIcon symbol={symbol} />
      <Text
        ml="4px"
        size="13px"
      >
        {symbol}
      </Text>
    </Flex>
    <div className="remove-icon">
      <Image
        src="/icon/close.svg"
        onClick={(e) => {
          e.stopPropagation();
          onRemove(symbol);
        }}
      />
    </div>
  </StockChipWrapper>
  );

export default StockChip;
